import React from "react";
import { ACCENT } from "../constants/quotationConstants";

export default function ElementContent({ el }) {
  if (el.type === "text" || el.type === "heading") {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          outline: "none",
          fontSize: el.fontSize,
          fontWeight: el.fontWeight,
          fontStyle: el.fontStyle || "normal",
          textDecoration: el.textDecoration || "none",
          color: el.color,
          textAlign: el.align,
          whiteSpace: "pre-wrap",
          lineHeight: 1.4,
          fontFamily: "Arial, sans-serif",
          overflow: "hidden",
        }}
      >
        {el.content}
      </div>
    );
  }

  if (el.type === "table") {
    const rowPct = 100 / el.rows.length;
    return (
      <table
        style={{
          width: "100%",
          height: "100%",
          borderCollapse: "collapse",
          tableLayout: "fixed",
          fontSize: el.fontSize,
          fontFamily: "Arial, sans-serif",
        }}
      >
        <tbody>
          {el.rows.map((row, ri) => (
            <tr key={ri} style={{ height: `${rowPct}%` }}>
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  style={{
                    border: "1px solid #D6DCE5",
                    padding: "5px 8px",
                    outline: "none",
                    background: ri === 0 ? ACCENT : "#fff",
                    color: ri === 0 ? "#fff" : "#222",
                    fontWeight: ri === 0 ? 600 : 400,
                    overflow: "hidden",
                  }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  if (el.type === "line") {
    return <div style={{ width: "100%", height: "100%", background: el.color }} />;
  }

  if (el.type === "rect") {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          background: el.color,
          border: `1px solid ${el.borderColor}`,
          borderRadius: 4,
        }}
      />
    );
  }

  if (el.type === "image") {
    return el.src ? (
      <img src={el.src} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} draggable={false} />
    ) : (
      <div
        style={{
          width: "100%",
          height: "100%",
          border: "1.5px dashed #B8C2D0",
          borderRadius: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 11,
          color: "#9AA5B5",
          background: "#F7F9FB",
        }}
      >
        No image URL set
      </div>
    );
  }

  return null;
}

export function renderElementContent(el) {
  return <ElementContent el={el} />;
}
